export const name = `Oluwatimilehin Oluyinka`;
export const email = `thetimoye@gmail.com`;
export const location = `Lagos, Nigeria`;

export const professionalExperience = [
    {
        title: `Data Engineer`,
        company: `Konga E-Commerce Group`,
        dateRange: `Sept. 2022 - Present`,
        location: `Lagos, Nigeria`
        , duties: [
            `Extract, transform, and load over 1TB volume of data into a columnar store for fast & complex analysis `,
            `Manage, monitor and test extracted dataset, ensuring 100% accuracy of data`,
            `Communicate with Business executives and data consumers to understand their needs, to deliver veracious, complete data`
        ]
    },
    {
        title: `Software Engineer`,
        company: `Summitech Computing Limited`,
        dateRange: `Nov. 2019 - Aug. 2022`,
        location: `Lagos, Nigeria`
        , duties: [
            `Collaborate with product managers, designers and engineers to build and maintain top-notch web and mobile applications`,
            `Write readable and reuseable code; allowing possibilities of future use`,
            `Review, refactor, and re-implement previously written codebase; keeping up with latest technologies and improving users’ experiences.`
        ]
    },
    {
        title: `Tech. Ops. Engineer`,
        company: `Summitech Computing Limited`,
        dateRange: `Mar. 2017 - Oct. 2019`,
        location: `Lagos, Nigeria`
        , duties: [
            `Trained non-tech savy staff on how to best make use of and handle computers and its accessories`,
            `Queried and gathered data from clients’ Microsoft SQL Database based on scenarios requested by cutomer service and finance teams.`,
            ``
        ]
    }
]


export const volunteerExperience = [
    {
        title: `Software Engineer`,
        company: `Datafest Africa`,
        dateRange: `May 2022 - Present`,
        location: `Lagos, Nigeria`
        , duties: [
            `Research and understand community principles and language in order to adopt practices and present ideas in technology as a team`,
            `Develop website as designed, find and apply fixes to bugs; ensuring proper website delivery`
        ]
    },
    {
        title: `Clinic Personnel Associate`,
        company: `Fesbach Free Clinics`,
        dateRange: `2015 - Present (Bi-annual)`,
        location: `Lagos, Nigeria`
        , duties: [
            `Peer with medical professionals to organize and cary out free clinics for persons of every age group`,
            `Measure and Monitor patients’ vitals - weights, heights. blood pressure, sugar levels.`,
            
        ]
    },
    {
        title: `Mathematics Teacher`,
        company: `Fesbach Summer School`,
        dateRange: `2012 - 2016`,
        location: `Lagos, Nigeria`
        , duties: [
            `Tutored over 50 students of different class groups (grades) per summer on how to understand mathematical problems and apply solutions`
        ]
    }
];


export const skills = [

    {title: 'Languages', content: [`Python`,
    `SQL`,
    `JavaScript`]},
    {
        title: 'Tools',
        content: [
            `PySpark`,
            `Airflow`,
            `Kafka`,
            `DBT`,
            `AWS Redshift`,
            `Azure Synapse`
        ],
    },   
    {title: `Expertise`, content: [`ETL`, `Warehousing`, `Monitoring`]}
]

export const degrees = [
    {
        major: `Computer Science`,
        university: `Redeemer's University`,
        award: `B.Sc`,
        year: `August 2012 - June 2016`,

    },
    {
        major: `Data Engineering`,
        university: `Udacity`,
        award: `Nano Degree`,
        year: `December 2020 - March 2021`,
        
    },
    {
        major: `Data Science with Python`,
        university: `Udacity`,
        award: `Nano Degree`,
        year: `October - December 2019`,
        
    }
];

export const languages = [
    `English`,
    `Yoruba`,
    `French (Basic)`
];

export const interests = [
    `Art`,
    `Books`
]